import React, { Component } from "react"
import * as matrix from "matrix-mab"
import * as haphazard from "haphazard"

export default class RandomMapGenerator extends Component {
    state = {
        data_is_valid: true,
        width: 400,
        height: 400,
        seed: 11110234679124,
        water_level: 6,
        smooth: 2,
        prime1: 611951,
        prime2: 611953,
        mask: 7,
        ocean_size: 2,
        show_download_link:false
    }

    editable =  {
        width: (v) => true,
        height: (v) => true,
        seed: (v) => true,
        water_level: (v) => true,
        smooth: (v) => true,
        mask: (v) => v > this.state.ocean_size,
        ocean_size: (v) => v < Math.floor(this.state.mask/2)
    }

    map_palette = [
        [ 23,  87, 126], //"#17577e"
        [ 61, 108,  66], //"#3d6c42"
        [ 63, 110,  66], //"#3f6e42"
        [ 71, 115,  64], //"#477340"
        [ 82, 123,  62], //"#527b3e"
        [ 97, 133,  59], //"#61853b"
        [114, 144,  56], //"#729038"
        [143, 164,  51], //"#8fa433"
        [175, 186,  45], //"#afba2d"
        [184, 192,  43], //"#b8c02b"
        [169, 166,  42], //"#a9a62a"
        [141, 115,  41], //"#8d7329"
        [117,  71,  39], //"#754727"
        [107,  53,  39], //"#6b3527"
        [131,  86,  74], //"#83564a"
        [195, 173, 167]  //"#c3ada7"
    ]

    validate_input(el) {
        if (el.name in this.editable) {
            const value = el.value
            if (this.editable[el.name](value) !== true) {
                el.parentNode.classList.add("error")
                return false
            }
            el.parentNode.classList.remove("error")
            return true
        }
        return true
    }

    change(e) {
        if (e.target.name in this.editable) {
            let value = e.target.value
            // document.getElementById("custom_map")[e.target.name] = e.target.value
            if (isNaN(parseInt(value, 10))) {
                value = 0
            }

            if (typeof this.editable[e.target.name] !== "function") {
                throw new Error("the 'editable' should be a distpach map: check your code")
            }

            return this.setState({
                [e.target.name]: parseInt(value, 10)
            })
        }
    }

    draw_map(e) {
        const component = this
        e.preventDefault()
        const download_link = document.getElementById("download_map_data")
        download_link.href=""

        let validation_passed = true;
        Object.keys(this.editable).forEach(function(key, index){
            console.log("key", key)
            const el = document.getElementById(key)
            if (el !== "undefined") {
                console.log("is defined", el.name)
                if(component.validate_input(el) !== true) {
                    console.log("error", el.name, component.validate_input(el))

                    document.getElementById(el.name)
                        .classList.add("error")
                    validation_passed = false
                } else {
                    el.classList.remove("error")
                    document.getElementById(el.name)
                        .classList.remove("error")
                }
            }
        })

        if(validation_passed === false) {
            return false
        }

        e.preventDefault()
        console.log(this.state)
        const width = this.state.width
        const height = this.state.height
        const random_gen = new haphazard.BBS(
            this.state.seed,
            this.state.prime1,
            this.state.prime2
        )

        const mask_gen = new haphazard.BBS(
            this.state.seed,
            this.state.prime1,
            this.state.prime2
        )

        const mask = make_mask(
            this.state.ocean_size,
            {
                width:  Math.floor(this.state.mask),
                height: Math.floor(this.state.mask)
            },
            {
                width: Math.floor(this.state.width),
                height: Math.floor(this.state.height)
            },
            mask_gen
        )

        const orig = matrix.random_matrix(
            width, height,
            (x,y) => random_gen.next()
        )
        const normalized = matrix.normalize_matrix(orig,0,7)
        const summed = matrix.add_matrices(normalized, mask)
        const smooth = matrix.moving_average(summed, this.state.smooth)

        const smooth_normal = matrix.normalize_matrix(smooth, 0, 15)
        const final = matrix.replace_elements(
            smooth_normal,
            (i) => i < this.state.water_level,
            () => 0
        )

        set_download_data(final, "map_data.json")
        const ctx = document.getElementById("custom_map").getContext("2d")
        draw_matrix(final, ctx, this.map_palette)

    }

    get_download_data(data) {
        const data_as_string = "data:text/json;charset=utf-8,"
                + encodeURIComponent(JSON.stringify(data))
        console.log("data_as_string", data_as_string)
        return data_as_string
    }


    render() { return (
<form className="map_generator_form">
<div className="form_controls">
    <div className="form_element_size">
    <label htmlFor="width">Width</label>
    <input type="text" name="width" id="width"
            value={this.state.width}
            onChange={ (e) => this.change(e)}
        />
    <br/>
    <label htmlFor="size">Height</label>
    <input type="text" name="height" id="height"
            value={this.state.height}
            onChange={ (e) => this.change(e)}
        />
    </div>

    <div className="form_element_seed">
    <label htmlFor="seed">Seed</label>
    <input type="text" name="seed" id="seed"
        value={this.state.seed}
        onChange={ (e) => this.change(e)}
    />
    </div>

    <div className="form_element_water_level">
    <label htmlFor="water_level">Water</label>
    <input type="text" name="water_level" id="water_level"
        value={this.state.water_level}
        onChange={ (e) => this.change(e)}
    />
    </div>

    <div className="form_element_smooth">
    <label htmlFor="smooth">Smooth</label>
    <input type="text" name="smooth" id="smooth"
        value={this.state.smooth}
        onChange={ (e) => this.change(e)}
    />
    </div>

    <div className="form_element_mask">
    <label htmlFor="mask">Mask</label>
    <input type="text" name="mask" id="mask"
        value={this.state.mask}
        onChange={ (e) => this.change(e)}
    />
    </div>

    <div className="form_element_ocean_size">
    <label htmlFor="ocean_size">Ocean size</label>
    <input type="text" name="ocean_size" id="ocean_size"
        value={this.state.ocean_size}
        onChange={ (e) => this.change(e)} />
    </div>
    <br/>

    <button onClick={(e) => this.draw_map(e)}>Draw map</button>
    <a id="download_map_data"
        className="button"
        target="_blank"
        rel="noopener noreferrer"
    >Save map as JSON</a>
</div>
<div className="map_container">
    <canvas id="custom_map"
        height={this.state.height}
        width={this.state.width}>
    </canvas>
</div>
</form>
    )}
}

function rgb_to_string(rgb, change) {
    if (
        Number.isInteger(change)
        && change >= -255
        && change <= 255
    ) {
        rgb = rgb.map( value => value + change >= 0 ? value + change : 0)
    }
    return "rgb(" + rgb.join(",") + ")"
}


function draw_matrix(matrix, ctx, palette) {
    matrix.forEach(
        (row, y) => {
            row.forEach(
                (item, x) => {
                    if (palette[item] !== "undefined") {
                        ctx.fillStyle = rgb_to_string(
                            palette[item]
                        )
                    } else {
                        ctx.fillStyle = "#ff0000"
                    }
                    ctx.fillRect(x,y,1,1)
                }
            )
        }
    )
}

function make_mask(ocean_size, initial_size, final_size, generator) {

    let mask = matrix.random_matrix(
        Math.floor(initial_size.width),
        Math.floor(initial_size.height),
        () => generator.next()
    )

    if(parseInt(ocean_size, 10) !== ocean_size) {
        throw new Error("ocean_size must be an integer")
    }

    if (ocean_size > 0) {
        const offset = {
            x: -ocean_size,
            y: -ocean_size
        }
        const new_size = {
            x: mask[0].length + (2 * ocean_size),
            y: mask.length + (2 * ocean_size),
        }
        const fill = () => 0
        const allow_cropping = true
        console.log("adding some ocean", offset, new_size)
        mask = matrix.resize(
            mask, offset, new_size, fill, allow_cropping
        )
        console.log("after ocean is added", mask)
    }

    const mask_scaled = matrix.stretch(mask, final_size.width, final_size.height)
    return matrix.normalize_matrix(mask_scaled, 0, 15)
}


function set_download_data(data, file_name) {

    const data_as_string = "data:text/json;charset=utf-8,"
            + encodeURIComponent(JSON.stringify(data, null, " "))
    console.log("data_as_string", data_as_string)
    const download_link = document.getElementById("download_map_data")
    download_link.setAttribute("href", data_as_string)
    download_link.setAttribute("download", file_name)
    download_link.disabled = false
}



// WEBPACK FOOTER //
// ./src/lib/components/util/RandomMapGenerator.js